import { useEffect, useState } from 'react';
import { Session } from '../services/Store';

export function useSession() {
    const [session, setSession] = useState(Session.get());

    useEffect(() => {
        const subscription = Session.stateChanged.subscribe(({ session }) => {
            setSession({ ...session });
        });
        return () => subscription.unsubscribe();
    }, [setSession, Session]);

    return session;
}
